import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/components/ui/tabs"

type TabsProps = {
    tabsTitle:string,
    Component:React.ReactNode,
}

type TabsWrapperProps={
    tabsComponents:TabsProps[],
    //numOfTabs:number,
    defaultValue:string,
    disabled?:boolean
}

const TabsWrapper = ({tabsComponents,defaultValue,disabled}:TabsWrapperProps) => {
    return (
        <Tabs defaultValue={defaultValue} className="w-full">
          <TabsList className={'flex w-full flex-wrap h-16'}>
            {tabsComponents.map((tab,index)=>{
              const {tabsTitle}=tab;
              return(
                <TabsTrigger className={`flex basis-1/3 h-full text-lg`} disabled={disabled} key={index} value={tabsTitle}>
                  {tabsTitle}
                </TabsTrigger>
              )
            })}
          </TabsList>
            {tabsComponents.map((tab,index)=>{
                const {Component,tabsTitle}=tab;
                return(
                <TabsContent key={index} value={tabsTitle} className="border-0">
                    {Component}
                </TabsContent>
                )
            })}
        </Tabs>
      )
    }


export default TabsWrapper